<template>
  <v-layout class="cvcql-frequency-inputs">
    <v-flex
      class="float-left"
      v-if="!readonly"
      :class="{
        'frequency-number-input-not-dense': !superDense,
        'frequency-number-input-dense': superDense,
      }"
    >
      <v-text-field
        required
        dense
        single-line
        type="number"
        class="mt-0"
        :class="{ 'text-field-no-input-padding': superDense }"
        min="1"
        :prepend-icon="showIcon ? 'mdi-timer-sand' : null"
        v-model="number"
        :error-messages="errors"
        @change="onChangeFrequency"
      />
    </v-flex>
    <span v-else>{{ number }} </span>

    <v-flex
      v-if="!readonly"
      class="float-right"
      :class="{
        'frequency-period-input-not-dense': !superDense,
        'frequency-period-input-dense': superDense,
      }"
    >
      <v-menu offset-y transition="slide-y-transition" class="mt-0">
        <template v-slot:activator="{ on, value }">
          <v-btn
            depressed
            color="transparent"
            v-on="on"
            right
            width="100%"
            class="no-uppercase"
            :class="{ 'pa-0': superDense }"
          >
            {{ periodText }}
            <v-icon v-if="!value && !superDense" large right
              >mdi-menu-down</v-icon
            >
            <v-icon v-else-if="!superDense" large right>mdi-menu-up</v-icon>
          </v-btn>
        </template>

        <v-list>
          <v-list-item-group
            mandatory
            v-model="periodText"
            @change="onChangeFrequency"
          >
            <v-list-item
              v-for="item in items"
              :key="`period-${item.text}`"
              :value="item.text"
              class="cursor-pointer"
            >
              <v-list-item-content>
                <v-list-item-title v-text="item.text" />
              </v-list-item-content>
            </v-list-item>
          </v-list-item-group>
        </v-list>
      </v-menu>
    </v-flex>

    <span v-else>
      {{ periodText }}
    </span>
  </v-layout>
</template>

<script>
export default {
  name: "CvcFrequencyInput",
  data: () => ({
    number: 0,
    periodText: "",
  }),
  props: {
    value: {
      required: true,
    },
    items: {
      required: false,
      default: () => {
        return [
          { text: "weeks", value: 7 * 86400 },
          { text: "days", value: 86400 },
        ];
      },
    },
    showIcon: {
      type: Boolean,
      default: true,
    },
    superDense: {
      type: Boolean,
      default: false,
    },
    errors: {
      type: Array[String],
      required: false,
      default: () => [],
    },
    onChange: {
      type: Function,
      required: false,
      default: () => {},
    },
    readonly: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    seconds: {
      get() {
        return (+this.number) * +this.period.value;
      },
      set(val) {
        // If a value is attempted to be set, we must pick a period first. So we pick the first one.
        if (!this.period) this.period = this.items[0].text;

        this.number = +val / +this.period.value;
      },
    },
    period() {
      return this.items.find((p) => this.periodText === p.text);
    }
  },
  methods: {
    onChangeFrequency() {
      this.onChange(+this.seconds);
      this.$emit("input", this.seconds);
    },
  },
  watch: {
    value: {
      handler(val) {
        if (isNaN(val))  val = 1

        // If a value is attempted to be set, we must pick a period first. So we pick the first one.
        if (!this.period) this.periodText = this.items[0].text;
        
        // Only values higher than 1 of the current period are allowed
        if (val < this.period.value) val = +this.period.value;
        
        this.seconds = val;
      },
      immediate: true,
    },
  },
};
</script>

<style lang="scss" scoped>
.frequency-number-input-not-dense {
  width: calc(100% - 104px);
  margin-top: 2px;
}
.frequency-number-input-dense {
  width: calc(100% - 84px);
  margin-top: 2px;
}
.frequency-period-input-not-dense {
  width: 100px;
  padding-left: 4px;
}
.frequency-period-input-dense {
  transform: translate(0, -4px);
  width: 80px;
  padding-left: 4px;
}
.no-uppercase {
  text-transform: none !important;
}
</style>
